import { render, staticRenderFns } from "./DownloadDialog.vue?vue&type=template&id=2c10d149&"
import script from "./DownloadDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadDialog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDialog.vue?vue&type=style&index=0&id=2c10d149&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports